import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  PAUSE,
  PERSIST,
  REGISTER,
  persistReducer,
  persistStore
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import puja from './features/ayodhyatra/puja/puja.slice'
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

const reducers = combineReducers({
  puja
});

// Define RootReducer type for the persistReducer
type RootReducer = ReturnType<typeof reducers>;

const persistConfig = {
  key: 'playmersiv',
  storage,
  version: 1,
  stateReconciler: autoMergeLevel2,
  whitelist: ['puja']
};

const persistedStore = persistReducer<RootReducer>(persistConfig, reducers);

const store = configureStore({
  reducer: persistedStore,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [PAUSE, PERSIST, REGISTER]
      }
    })
});

// Define types after store initialization
type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

const persistor = persistStore(store);

// Create properly typed hooks
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
const useAppDispatch = () => useDispatch<AppDispatch>();

export { persistor, store, reducers, useAppSelector, useAppDispatch };
export type { RootState, AppDispatch };
